import * as actionTypes from "../actionTypes";
import * as ImmersionGQL from "../../../gql";

export const setParticipantListLoading = (loading: boolean) => ({
  type: actionTypes.SET_PARTICIPANT_LIST_LOADING,
  payload: loading
});

export const initParticipantListMsg = () => ({
  type: actionTypes.INIT_PARTICIPANT_LIST_MSG
});

const updateParticipantListMsg = (message: string, msgType: string) => ({
  type: actionTypes.UPDATE_PARTICIPANT_LIST_MSG,
  payload: {
    message,
    msgType
  }
});

export const initParticipantListData = () => ({
  type: actionTypes.INIT_PARTICIPANT_LIST_DATA
});

export const initListDetailData = () => ({
  type: actionTypes.INIT_LIST_DETAIL_DATA
});

export const updateListDetailPage = (page: number) => ({
  type: actionTypes.UPDATE_LIST_DETAIL_PAGE,
  payload: page
});

export const startParticipantListCreate = (startNewList: boolean) => ({
  type: actionTypes.START_PARTICIPANT_LIST_CREATE,
  payload: startNewList
});

export const onStartAddParticipants = (startAddParticipants: boolean) => ({
  type: actionTypes.START_ADD_PARTICIPANTS,
  payload: startAddParticipants
});

export const manageParticipantList = (client: any, request: any, isAdding: boolean, callback: any) => {
  return (dispatch: any) => {
    dispatch(setParticipantListLoading(true));

    client.mutate({
      mutation: ImmersionGQL.manageParticipantList,
      fetchPolicy: "no-cache",
      variables: { ...request }
    }).then((res: any) => {
      if (res.data.manageParticipantsGroup && res.data.manageParticipantsGroup.status === 'true') {
        if (isAdding) {
          const insertedData = res.data.manageParticipantsGroup['data'];
          dispatch(setParticipantListLoading(false));
          callback(insertedData);
        } else {
          callback(true);
        }
      } else {
        callback(isAdding ? null : false);
        dispatch(setParticipantListLoading(false));
      }
    }).catch(() => {
      callback(isAdding ? null : false);
      dispatch(setParticipantListLoading(false));
    })
  }
};

const updateParticipantList = (res: any) => ({
  type: actionTypes.UPDATE_PARTICIPANT_LISTS,
  payload: res
});

export const getParticipantList = (client: any, setLoading: boolean) => {
  return (dispatch: any) => {
    setLoading && dispatch(setParticipantListLoading(true));

    client.query({
      query: ImmersionGQL.getParticipantLists,
      fetchPolicy: "no-cache",
      variables: { }
    }).then((res: any) => {
      if (res.data.getParticipantsGroup) {
        dispatch(updateParticipantList(res.data.getParticipantsGroup));
        dispatch(setParticipantListLoading(false));
      }
    }).catch(() => {
      dispatch(updateParticipantList(null));
      dispatch(setParticipantListLoading(false));
    })
  }
};

export const deleteParticipantList = (client: any, request: any, callback: any) => {
  return (dispatch: any) => {
    dispatch(setParticipantListLoading(true));

    client.mutate({
      mutation: ImmersionGQL.deleteParticipantList,
      fetchPolicy: "no-cache",
      variables: { ...request }
    }).then((res: any) => {
      if (res.data.deleteGroup && res.data.deleteGroup.status === 'true') {
        callback(true);
      }
    }).catch(() => {
      callback(false);
      dispatch(setParticipantListLoading(false));
    });
  }
};

const updateListParticipants = (res: any) => ({
  type: actionTypes.UPDATE_LIST_PARTICIPANTS,
  payload: res
});

export const getListParticipants = (client: any, request: any, setLoading: boolean) => {
  return (dispatch: any) => {
    setLoading && dispatch(setParticipantListLoading(true));

    client.query({
      query: ImmersionGQL.getListParticipants,
      fetchPolicy: "no-cache",
      variables: { ...request }
    }).then((res: any) => {
      if (res.data.getParticipantsList) {
        dispatch(updateListParticipants(res.data.getParticipantsList));
        dispatch(setParticipantListLoading(false));
      }
    }).catch(() => {
      dispatch(updateListParticipants(null));
      dispatch(setParticipantListLoading(false));
    })
  }
};

export const removeParticipantsFromList = (client: any, request: any, callback: any) => {
  return (dispatch: any) => {
    dispatch(setParticipantListLoading(true));

    client.mutate({
      mutation: ImmersionGQL.removeParticipantsFromList,
      fetchPolicy: "no-cache",
      variables: { ...request }
    }).then((res: any) => {
      if (res.data.removeGroupParticipants) {
        dispatch(updateParticipantListMsg(res.data.removeGroupParticipants['message'], 'success'));
        callback(true);
      }
    }).catch(() => {
      dispatch(updateParticipantListMsg('Participants removing failed', 'error'));
      callback(false);
      dispatch(setParticipantListLoading(false));
    });
  }
};

export const onAddParticipantsToList = (client: any, request: any, callback: any) => {
  return (dispatch: any) => {
    dispatch(setParticipantListLoading(true));

    client.mutate({
      mutation: ImmersionGQL.addParticipantsToList,
      fetchPolicy: "no-cache",
      variables: { ...request }
    }).then((res: any) => {
      if (res.data.addGroupParticipants) {
        dispatch(updateParticipantListMsg(res.data.addGroupParticipants['message'], 'success'));
        callback(true);
      }
    }).catch(() => {
      dispatch(updateParticipantListMsg('Participants adding failed', 'error'));
      callback(false);
      dispatch(setParticipantListLoading(false));
    });
  }
};

export const onUpdateTags = (client: any, request: any, callback: any) => {
  return (dispatch: any) => {
    dispatch(setParticipantListLoading(true));

    client.mutate({
      mutation: ImmersionGQL.editTags,
      fetchPolicy: "no-cache",
      variables: { ...request }
    }).then((res: any) => {
      if (res.data.addRemoveTags) {
        callback(true);
      }
    }).catch(() => {
      callback(false);
      dispatch(setParticipantListLoading(false));
    })
  };
};